import React from 'react';

function CapitalizedText(props) {    
    return (
        props.charAt(0).toUpperCase() + props.slice(1)
    ); 
}

export default CapitalizedText;